module.exports = __webpack_public_path__ + "static/media/unforgettable_weddings.582161bc.png";